import React from 'react'
import { TextField } from '@cicero/ui'
import { set } from '@cicero/data/utils'
import { HasValue, TextEquals } from './conditions'
import { IPageFilterOption } from './helpers'
import { AttributeDoc, AttributeSchema, AttributeType } from '../AttributeSchema'
import { AttributeOptionChooser, PageChooser, UserChooser } from 'forms'

const conditions = [TextEquals, HasValue] // default basic conditions

export const GenerateAttributeFilter = (attr: AttributeDoc): IPageFilterOption<any> => {
  return {
    id: attr.id,
    label: attr.label,
    type: 'attribute',
    key: AttributeSchema.TYPE_CONFIG[attr.type].valueKey,
    conditions,
    addToQuery(q) {
      set(q.selector, 'attribute_id', attr.id)
      return q
    },
    prepareTerm(doc) {
      switch (attr.type) {
        case AttributeType.option:
        case AttributeType.linkedpage:
          return typeof doc === 'string' ? doc : Array.isArray(doc) ? doc.map(d => d.id) : doc?.id || true

        default:
          return doc
      }
    },
    renderForm(value, setValue) {
      switch (attr.type) {
        case AttributeType.option:
          return <AttributeOptionChooser name="option" attribute={attr} value={value} onChange={(e) => setValue(e.target.value)} />

        case AttributeType.linkeduser:
          return <UserChooser name="user" value={value} onChange={(e) => setValue(e.target.value)} />

        case AttributeType.linkedpage:
          return <PageChooser name="page" value={value} onChange={(e) => setValue(e.target.value)} />

        default:
          return <TextField variant="outlined" value={value} onChange={(e) => setValue(e.target.value)} />
      }
    },
  }
}
